// extracted by mini-css-extract-plugin
export default {"container":"container-qsyW8ctb","avatar":"avatar-JJty_TC1","showHideTradeIcon":"showHideTradeIcon-Ei0woPsb"};